import { render, staticRenderFns } from "./PatientVerificationTable.vue?vue&type=template&id=cfb07c70&scoped=true"
import script from "./PatientVerificationTable.vue?vue&type=script&lang=js"
export * from "./PatientVerificationTable.vue?vue&type=script&lang=js"
import style0 from "./PatientVerificationTable.vue?vue&type=style&index=0&id=cfb07c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb07c70",
  null
  
)

export default component.exports